<body class="ltr main-body leftmenu">
  <form autocomplete="off" novalidate [formGroup]="ledgerForm">
    <div class="main-content side-content pt-0 ml-0">
      <div class="main-container container-fluid">
        <div class="inner-body">

          <div class="row row-sm add-form">
            <div class="col-lg-12 col-md-12">
              <div class="card custom-card">
                <div class="card-body">

                  <!-- ── Header ─────────────────────────────────── -->
                  <div class="row row-sm">
                    <div class="col-md-8">
                      <div class="d-flex align-items-center pl-3">
                        <img alt="Logo" src="../../assets/img/dashboard.png"
                             class="mh-45px pb-2">
                        <p class="mb-1">
                          <span class="main-content-label">
                            <b>{{ TitleOne }}</b>
                          </span><br>
                        </p>
                      </div>
                    </div>
                  </div>

                  <!-- ── Form row ───────────────────────────────── -->
                  <div class="row clearfix">

                    <!-- Session -->
                    <div class="col-sm-3">
                      <div class="form-group">
                        <mat-form-field appearance="outline" class="example-full-width">
                          <mat-label>Session</mat-label>
                          <mat-select #sessionSelect
                                      class="colorblack"
                                      formControlName="Session"
                                      placeholder="Session"
                                      (selectionChange)="onSessionChange($event.value)"
                                      required>
                            <mat-select-filter *ngIf="sessionSelect.focused"
                                               [placeholder]="'Search Session...'"
                                               [displayMember]="'SnName'"
                                               [array]="sessionList"
                                               (filteredReturn)="filteredSessionList = $event">
                            </mat-select-filter>
                            <mat-option *ngFor="let item of filteredSessionList"
                                        [value]="item.SnNo">
                              {{ item.SnName }}
                            </mat-option>
                            <mat-option *ngIf="!sessionList?.length" disabled>
                              Loading sessions...
                            </mat-option>
                          </mat-select>
                          <mat-error *ngIf="ledgerForm.controls['Session'].touched
                                          && ledgerForm.controls['Session'].errors?.required">
                            Mandatory
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>

                    <!-- Exam -->
                    <div class="col-sm-3">
                      <div class="form-group">
                        <mat-form-field appearance="outline" class="example-full-width">
                          <mat-label>Exam</mat-label>
                          <mat-select #examSelect
                                      class="colorblack"
                                      formControlName="Exam"
                                      placeholder="Exam"
                                      required>
                            <mat-select-filter *ngIf="examSelect.focused"
                                               [placeholder]="'Search Exam...'"
                                               [displayMember]="'EmName'"
                                               [array]="examList"
                                               (filteredReturn)="filteredListExam = $event">
                            </mat-select-filter>
                            <mat-option *ngFor="let item of filteredListExam"
                                        [value]="item.ShId"
                                        (click)="onExamChange(item)">
                              {{ item.EmCode }} - {{ item.EmName }}
                            </mat-option>
                            <mat-option *ngIf="!examList?.length" disabled>
                              Select Session first
                            </mat-option>
                            <mat-option *ngIf="examList?.length && filteredListExam?.length === 0"
                                        disabled>
                              No exams found
                            </mat-option>
                          </mat-select>
                          <mat-error *ngIf="ledgerForm.controls['Exam'].touched
                                          && ledgerForm.controls['Exam'].errors?.required">
                            Mandatory
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>

                    <!-- Course (optional) -->
                    <div class="col-sm-3">
                      <div class="form-group">
                        <mat-form-field appearance="outline" class="example-full-width">
                          <mat-label>Course</mat-label>
                          <mat-select #courseSelect
                                      class="colorblack"
                                      formControlName="Course"
                                      placeholder="Course">
                            <mat-select-filter *ngIf="courseSelect.focused"
                                               [placeholder]="'Search Course...'"
                                               [displayMember]="'CoName'"
                                               [array]="courseList"
                                               (filteredReturn)="filteredListCourse = $event">
                            </mat-select-filter>
                            <mat-option *ngFor="let item of filteredListCourse"
                                        [value]="item.CoCode">
                              {{ item.CoName }}
                            </mat-option>
                            <mat-option *ngIf="!courseList?.length" disabled>
                              No courses
                            </mat-option>
                            <mat-option *ngIf="courseList?.length && filteredListCourse?.length === 0"
                                        disabled>
                              No courses found
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>

                    <!-- Paper (optional) -->
                    <!-- <div class="col-sm-3">
                      <div class="form-group">
                        <mat-form-field appearance="outline" class="example-full-width">
                          <mat-label>Paper</mat-label>
                          <mat-select #paperSelect
                                      class="colorblack"
                                      formControlName="Paper"
                                      placeholder="Paper">
                            <mat-select-filter *ngIf="paperSelect.focused"
                                               [placeholder]="'Search Paper...'"
                                               [displayMember]="'SubName'"
                                               [array]="paperList"
                                               (filteredReturn)="filteredListPaper = $event">
                            </mat-select-filter>
                            <mat-option *ngFor="let item of filteredListPaper"
                                        [value]="item.EsId">
                              {{ item.SubName }}
                            </mat-option>
                            <mat-option *ngIf="!paperList?.length" disabled>
                              Select Exam first
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div> -->

                  </div>

                  <!-- ── Signature Name / Designation rows ───────── -->
                  <div class="row clearfix">

                    <div class="col-sm-3">
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Name</mat-label>
                        <input maxlength="150" matInput formControlName="Name1">
                      </mat-form-field>
                    </div>
                    <div class="col-sm-3">
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Designation</mat-label>
                        <input maxlength="150" matInput formControlName="Designation1">
                      </mat-form-field>
                    </div>

                    <div class="col-sm-3">
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Name</mat-label>
                        <input maxlength="150" matInput formControlName="Name2">
                      </mat-form-field>
                    </div>
                    <div class="col-sm-3">
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Designation</mat-label>
                        <input maxlength="150" matInput formControlName="Designation2">
                      </mat-form-field>
                    </div>

                    <div class="col-sm-3">
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Name</mat-label>
                        <input maxlength="150" matInput formControlName="Name3">
                      </mat-form-field>
                    </div>
                    <div class="col-sm-3">
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Designation</mat-label>
                        <input maxlength="150" matInput formControlName="Designation3">
                      </mat-form-field>
                    </div>

                    <div class="col-sm-3">
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Name</mat-label>
                        <input maxlength="150" matInput formControlName="Name4">
                      </mat-form-field>
                    </div>
                    <div class="col-sm-3">
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Designation</mat-label>
                        <input maxlength="150" matInput formControlName="Designation4">
                      </mat-form-field>
                    </div>

                    <div class="col-sm-3">
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Name</mat-label>
                        <input maxlength="150" matInput formControlName="Name5">
                      </mat-form-field>
                    </div>
                    <div class="col-sm-3">
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Designation</mat-label>
                        <input maxlength="150" matInput formControlName="Designation5">
                      </mat-form-field>
                    </div>

                    <div class="col-sm-3">
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Name</mat-label>
                        <input maxlength="150" matInput formControlName="Name6">
                      </mat-form-field>
                    </div>
                    <div class="col-sm-3">
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Designation</mat-label>
                        <input maxlength="150" matInput formControlName="Designation6">
                      </mat-form-field>
                    </div>

                  </div>

                  <!-- ── Buttons ────────────────────────────────── -->
                  <div class="row">
                    <div class="col-sm-12 prpl">

                      <button type="button"
                              class="btn sz btn-primary btn-icon-text floatright mt-1"
                              (click)="onPrintLedger()">
                        <span style="display: flex; align-items: center;">
                          <img width="20" height="20"
                               src="../../assets/img/printer.gif"
                               alt="Print Icon" style="margin-right: 5px;">
                          Print
                        </span>
                      </button>

                      <button type="button"
                              (click)="back()"
                              class="btn sz btn-primary btn-icon-text floatright mt-1 fr">
                        <span style="display: contents; align-items: center;">
                          <img width="20vh"
                               src="../../assets/img/turn-left.gif"
                               style="margin-right: 5px;">
                          Back
                        </span>
                      </button>

                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </form>
</body>